import {
    RECOMMENDED_PRODUCTS,
    SET_BULK_PRODUCT_DETAILS
} from '../../config/types'

export default function (state = [], action) {
    switch (action.type) {
        // case ALL_PRODUCTS:
        //     return action.payload;
        case RECOMMENDED_PRODUCTS:
            return { ...state, recommended: action.payload }
        case SET_BULK_PRODUCT_DETAILS:
            return { ...state, bulkProductDetails: action.payload }
        default:
            return state;
    }

}